module.exports = __webpack_public_path__ + "static/media/airbnb_logo_small.a0ccd805.png";